const NAMESPACE = "clientAttachment";

const KEYS = {
    viewSensitiveAttachmentHeader: "viewSensitiveAttachmentHeader",
    downloadSensitiveAttachmentHeader: "downloadSensitiveAttachmentHeader",
    confirmRevealAttachmentMessage: "confirmRevealAttachmentMessage",
    cancelButtonText: "cancelButtonText",
    okButtonText: "okButtonText"
};

const MESSAGES = {
    [KEYS.viewSensitiveAttachmentHeader]: {
        value: "View Sensitive Attachment",
        comment: "Confirm view sensitive attachment dialog header"
    },
    [KEYS.downloadSensitiveAttachmentHeader]: {
        value: "Download Sensitive Attachment",
        comment: "Confirm download sensitive attachment dialog header"
    },
    [KEYS.confirmRevealAttachmentMessage]: {
        value: "Are you sure you want to reveal this sensitive information?",
        comment: "Confirm reveal sensitive attachment dialog message text"
    },
    [KEYS.cancelButtonText]: {
        value: "Cancel",
        comment: "Cancel button text"
    },
    [KEYS.okButtonText]: {
        value: "OK",
        comment: "OK button text"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
